module.exports = __webpack_public_path__ + "img/area-1.1c58bcc8.png";